import { useState, useEffect, useRef } from 'react'
import useSWR, { type SWRResponse, type SWRConfiguration, type Key, unstable_serialize } from 'swr'
import { debounce } from 'throttle-debounce'

type FetcherFn<Data> = (...args: any[]) => Promise<Data>

export default function useDebouncedSWR<Data = any, Error = any>(
	key: Key,
	fn: FetcherFn<Data>,
	config?: SWRConfiguration<Data, Error>,
	debounceTime: number = 1000,
): SWRResponse<Data, Error> {
	const serializedKey = unstable_serialize(key)
	const [localKey, setLocalKey] = useState<Key>(key)
	const res = useSWR<Data, Error>(localKey, (key) => {
		const args = Array.isArray(key) ? key : [key]
		return fn(...args)
	}, config)
	const handleLocalKeyUpdate = useRef(debounce(debounceTime, setLocalKey))
	useEffect(() => {
		handleLocalKeyUpdate.current(key)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [serializedKey])

	return res
}
